// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".controller[data-v-314bc211]{padding:0;margin-bottom:20px}.top[data-v-314bc211]{display:flex;align-items:center;width:100%;padding:20px;min-height:40px}.permission-controller[data-v-314bc211],.top .buttons-block[data-v-314bc211]{display:flex;align-items:center;margin-left:auto}.permission-controller[data-v-314bc211]{justify-content:flex-end}.btn[data-v-314bc211]{margin-left:20px}", ""]);
// Exports
module.exports = exports;
